import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
  Card,
  Form
} from "react-bootstrap";
import { appConfig } from "../../config";

import ReactPaginate from "react-paginate";
import Switch from "react-switch";
var dateFormat = require("dateformat");

class StatusChangeOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {}
    };
  }

  Submit = () => {
    let value = this.props.OrderStatusdtList;
    // console.log("valueyyyyyyyyyyyy", this.props.OrderStatusdtList);
    this.props.ordersShippedActive(value);
    this.props.closeOrderStatusModel();
    // this.props.resetprogressPage();
  };
  render() {
    const data =
      this.props.OrderStatusdtList && this.props.OrderStatusdtList.item
        ? this.props.OrderStatusdtList && this.props.OrderStatusdtList.item
        : null;
    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.showOrderStatusModel}
            onHide={this.props.closeOrderStatusModel}
            animation={false}
            size="md"
            backdrop="static"
            className="Modalmodelboxdesigns"
            centered={true}
            // style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
          >
            
            <Modal.Body>
              <div>
                <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                  <b>Order dispatched?</b>
                </h6>
              </div>
              <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Button
                    variant="danger"
                    className="cmnDelCnclBtn"
                    onClick={() => this.props.closeOrderStatusModel()}
                  >
                    No
                  </Button>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Button
                    variant="success"
                    className="cmnDelOkBtn"
                    onClick={this.Submit}
                  >
                    Yes
                  </Button>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

export default StatusChangeOrders;
